import type { UserRole } from '@/shared/types';

interface RoleHelpers {
  isProvider: boolean;
  isShopOwner: boolean;
  isCustomer: boolean;
}

/**
 * Hook to provide helper functions for checking user roles
 */
export const useRoleHelpers = (role: UserRole | null): RoleHelpers => {
  // Role-based utility boolean flags
  const isProvider =
    role === 'independent_provider' ||
    role === 'shop_owner' ||
    role === 'shop_manager' ||
    role === 'staff_provider';

  const isShopOwner = role === 'shop_owner';

  const isCustomer = role === 'client';

  return {
    isProvider,
    isShopOwner,
    isCustomer,
  };
};
